function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.8 25c0 13.806-11.194 25-25 25-13.807 0-25-11.194-25-25 0-13.807 11.194-25 25-25 13.807 0 25 11.194 25 25z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24.248 34.7l9.7-9.7-9.7-9.7-2.752 2.753L28.445 25l-6.949 6.947z"
}));

function SvgIconNextArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNNTAuOCAyNWMwIDEzLjgwNi0xMS4xOTQgMjUtMjUgMjUtMTMuODA3IDAtMjUtMTEuMTk0LTI1LTI1IDAtMTMuODA3IDExLjE5NC0yNSAyNS0yNSAxMy44MDcgMCAyNSAxMS4xOTQgMjUgMjV6IiBmaWxsPSIjMDAwIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTI0LjI0OCAzNC43bDkuNy05LjctOS43LTkuNy0yLjc1MiAyLjc1M0wyOC40NDUgMjVsLTYuOTQ5IDYuOTQ3eiIvPjwvZz48L3N2Zz4K";
export { SvgIconNextArrow as ReactComponent };